import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];


  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }


  showToast(message: string, isSuccess: boolean = false) {

    if (isSuccess) {
      this.show(message, { classname: 'bg-success text-light', delay: 10000 });

    }
    else {
      this.show(message, { classname: 'bg-danger text-light', delay: 15000 });
    }

  }

}
